<template>
  <nuttrema-layout-content>
    <template slot="header">
      <sys-admin-instance-standard-header
        :meta="meta"
        :showEdit="false"
        :SysAdminInstanceDetails="SysAdminInstanceDetails">
      </sys-admin-instance-standard-header>
    </template>

    <template slot="central">
      <nuttrema-loader v-if="SysAdminInstanceSubscriptionsList.fetching"></nuttrema-loader>
      <template v-else>
        <instance-subscriptions-list
          :meta="meta"
          :state="_get(SysAdminInstanceSubscriptionsList, 'data', [])">
        </instance-subscriptions-list>
      </template>
    </template>

    <router-view slot="overflow"></router-view>
  </nuttrema-layout-content>
</template>

</template>

<script>
import PageProps from 'components/mixins/page-props';

import NuttremaLayoutContent from 'components/ui/layout/nuttrema-layout-content';
import SysAdminInstanceStandardHeader from 'components/pages/system-administration/instances/shared/cmpt-sys-admin-instance-standard-header';

import InstanceSubscriptionsList from './cmpt-instance-subscriptions-list';

export default {
  name: 'page-sys-admin-instance-subscriptions-list',
  mixins: [PageProps],
  props: {
    id: {
      required: false,
      default: null,
    },
  },
  components: {
    NuttremaLayoutContent,
    SysAdminInstanceStandardHeader,
    InstanceSubscriptionsList,
  },
  data() {
    return {
      edit: false,
    };
  },
  computed: {
    SysAdminInstanceDetails() {
      return this.$store.getters.SysAdminInstanceDetails(this.id);
    },
    SysAdminInstanceSubscriptionsList() {
      return this.$store.getters.SysAdminInstanceSubscriptionsList(this.id);
    },
  },
  created() {
    this.$store.dispatch('GetSysAdminInstanceSubscriptionsList', { id: this.id });
  },
  beforeDestroy() {
    this.$store.dispatch('ClearSysAdminInstanceSubscriptionsList', { id: this.id });
  },
};
</script>



// WEBPACK FOOTER //
// src/components/pages/system-administration/instances/subscriptions/list/page-sys-admin-instance-subscriptions-list.vue